<template>
  <div class="loginHeader">
    <div class="w1300">
      <div class="logo">
        <router-link to="/" class="flex-cc">
          <el-image :src="require('@/assets/logo.png')"></el-image>
          <div class="xian"></div>
          <div class="tit-18 cor-000">UniXMAII</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.loginHeader {
  position: sticky;
  top: 0;
  z-index: 3;
  height: 70px;
  background: #fff;
  border-bottom: 1px solid #dfdfdf;
  .w1300 {
    height: 100%;
  }
  .logo {
    max-width: 50%;
    height: 100%;
    display: flex;
    align-items: center;

    .xian {
      width: 1px;
      height: 0.22rem;
      background: #cbcbcb;
      margin: 0 0.2rem;
    }

    img {
      max-width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

@media screen and (max-width: 767px) {
  .loginHeader {height: 60px;}
}

</style>
